import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Row, Col, Container, Dropdown } from 'react-bootstrap';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import './HeaderTopbar.css';
import { IHeaderTopbarProps, ButtonVariant } from '../../types/IHeader';
import Button from '../../Atoms/Buttons/';

const HeaderTopbar: React.FC<IHeaderTopbarProps> = ({
  brandAlt,
  brandSrc,
  brandWidth,
  brandHeight,
  brandClassName,
  brandURL,
  welcomeMessage,
  topBarHeading,
  isBrandVisible,
  isTopBarHeadingVisible,
  isButtonVisible,
  buttonArray,
  dropdownButtonArray,
}) => {
  const brandLogo = (
    <img
      alt={brandAlt}
      src={brandSrc}
      width={brandWidth}
      height={brandHeight}
      className={brandClassName}
      tabIndex={0}
      aria-label={brandAlt}
    />
  );

  const brandLink = brandURL ? (
    <Link to={brandURL} tabIndex={0}>
      {brandLogo}
    </Link>
  ) : (
    brandLogo
  );

  return (
    <Row>
      <Col>
        <Container fluid>
          <Row>
            <Col className="px-4">
              <Navbar className="top-nav py-0" collapseOnSelect expand="lg">
                {isBrandVisible && (
                  <Navbar.Brand className="py-0 sl-small-1-5">
                    {brandLink}
                  </Navbar.Brand>
                )}
                {isTopBarHeadingVisible && (
                  <Navbar.Text className="brand-text py-0 sr-large-auto">
                    {topBarHeading}
                  </Navbar.Text>
                )}
                {welcomeMessage ? (
                  <Navbar.Text className="welcome-msg">
                    {welcomeMessage}
                  </Navbar.Text>
                ) : (
                  ''
                )}
                {isButtonVisible && (
                  <div className="hide-small-screen">
                    {buttonArray && buttonArray.length
                      ? buttonArray.map((button, index) => {
                          const buttonLabel = (
                            <span
                              className={
                                button.variant === ButtonVariant.Secondary
                                  ? 'button-label'
                                  : ''
                              }
                            >
                              {button.label}
                            </span>
                          );
                          return button.variant === ButtonVariant.Primary ? (
                            <Button
                              key={index}
                              onClick={button.onClick}
                              variant={ButtonVariant.Link}
                              label={buttonLabel}
                            ></Button>
                          ) : (
                            <Button
                              key={index}
                              icon={faUser}
                              onClick={button.onClick}
                              variant={ButtonVariant.Secondary}
                              label={buttonLabel}
                            ></Button>
                          );
                        })
                      : []}
                  </div>
                )}
                {dropdownButtonArray && dropdownButtonArray.length && (
                  <Dropdown>
                    <Dropdown.Toggle
                      className="dropdown-custombutton"
                      id="dropdown-basic"
                    >
                      {dropdownButtonArray[0].label}
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      {dropdownButtonArray.map((item, index) => {
                        return (
                          index > 0 && (
                            <Dropdown.Item
                              href="javascript:void(0)"
                              key={index}
                              onClick={item.onClick}
                            >
                              {item.label}
                            </Dropdown.Item>
                          )
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </Navbar>
            </Col>
          </Row>
        </Container>
      </Col>
    </Row>
  );
};

export default HeaderTopbar;
